import Action from '../Action';
import OrderService from '../../services/OrderService';
import { message } from 'antd';
import FeatureAdOrderService from '../../services/FeatureAdOrderService';
import ExpertBuyOrderService from '../../services/ExpertBuyOrderService';
import DocumentVerificationOrderService from '../../services/DocumentVerificationOrderService';

export function fetchOrders() {
	return (dispatch) => {
		OrderService.getOrders()
			.then((orders) => dispatch({ type: Action.FETCH_ORDERS, orders: orders.data }))
			.catch((error) => message.error('Failed to fetch orders!'));
	};
}

export function fetchFeatureAdOrders() {
	return (dispatch) => {
		FeatureAdOrderService.getOrders()
			.then((orders) => dispatch({ type: Action.FETCH_FEATURE_AD_ORDERS, orders: orders.data }))
			.catch((error) => message.error('Failed to fetch orders!'));
	};
}

export function fetchExpertBuyOrders() {
	return (dispatch) => {
		ExpertBuyOrderService.getOrders()
			.then((orders) => dispatch({ type: Action.FETCH_EXPERT_BUY_ORDERS, orders: orders.data }))
			.catch((error) => message.error('Failed to fetch orders!'));
	};
}

export function fetchDocVerOrders() {
	return (dispatch) => {
		DocumentVerificationOrderService.getOrders()
			.then((orders) => dispatch({ type: Action.FETCH_DOC_VER_ORDERS, orders: orders.data }))
			.catch((error) => message.error('Failed to fetch orders!'));
	};
}

export function addOrder(body) {
	return (dispatch) => {
		OrderService.add(body)
			.then((order) => {
				dispatch({ type: Action.POST_ORDERS });
				message.success('Order added');
			})
			.catch((error) => message.error('Failed to add Order!'));
	};
}

export function updateOrder(id, body) {
	return (dispatch) => {
		OrderService.update(id, body)
			.then((orders) => {
				dispatch({ type: Action.UPDATE_ORDERS, order: orders.data });
				message.success('Order Updated');
			})
			.catch((error) => message.error('Failed to edit order!'));
	};
}

export function deleteOrder(id) {
	return (dispatch) => {
		OrderService.delete(id)
			.then((orders) => {
				dispatch({ type: Action.DELETE_ORDERS, order: orders.data });
				message.success('Order Deleted');
			})
			.catch((error) => message.error('Failed to delete order!'));
	};
}
